<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JjyCUd/tc-custom/9781982140632.jpg?1730521353829" alt="This image is the cover for the book More Beautiful Than Death, Star Trek: The Original Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">More Beautiful Than Death, Star Trek: The Original Series
      </h1>
      <p class="bookDescription body article font2">
        <b>An original novel based on the thrilling new <i>Star Trek</i> movies!</b><br/><br/>Based on the “Kelvin Universe” movie saga!<br/><br/>Captain James T. Kirk and the <i>Enterprise</i> crew escort Spock’s father, Ambassador Sarek of Vulcan, to a dilithium-rich planet called Akiron. They arrive to find this world under siege by creatures that some of the planet’s denizens believe are demons. Sarek orders Kirk to abandon the mission, but the young captain won’t turn his back on people in danger. After a harrowing encounter with the dark-energy “demons,” Kirk’s belief in a rational universe is challenged by a mystic who insists that it wasn’t coincidence that brought Kirk to Akiron, but the alien equivalent of a Karmic debt.<br/><br/>Meanwhile, aboard the <i>Enterprise</i>, Sarek’s young Vulcan aide L’Nel has a sinister agenda—and its chief objective appears to be the cold-blooded murder of Spock!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Mack
      </h2>
      
      <p class="authorDescription body article">David Mack is the multi-award-winning and the <I>New York Times </I>bestselling author of thirty-eight&#160;novels of science fiction, fantasy, and adventure, including the Star Trek Destiny and Cold Equations trilogies. His extensive writing credits include episodes of <I>Star Trek: Deep Space Nine</I>, and he worked as a consultant on season one of the animated series <I>Star Trek: Prodigy</I>. Honored in 2022 as a Grand Master by the International Association of Media Tie-in Writers, Mack resides in New York City.<BR><BR>&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fa897a6